import { Tab as AriaTab, type TabProps as AriaTabProps } from "react-aria-components";
import { tv } from "tailwind-variants";

import { cn } from "@/lib/helpers/cn";

export function Tab2({ children, className, ...props }: AriaTabProps) {
  const { tab } = styles();

  return (
    <AriaTab className={cn(tab(), className)} {...props}>
      {children}
    </AriaTab>
  );
}
const styles = tv({
  slots: {
    tab: cn(
      "tw:flex tw:items-center tw:gap-2",
      "tw:px-1.5 tw:py-4",
      "tw:cursor-pointer tw:outline-none",
      "tw:text-sm tw:font-semibold tw:text-text-tertiary",
      "tw:border-b-2 tw:border-b-transparent",
      "tw:transition-colors tw:duration-150",
      "tw:hover:text-text-teal-primary",
      "tw:selected:border-b-stroke-teal-primary tw:selected:text-text-teal-primary",
      "atom-keyboard-focus",
    ),
  },
});
